import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class ContentCategory {
	constructor() {
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		this.handleLoadMore();
		this.handleFiltering();
		this.fadeinRegister();
	}

	handleLoadMore() {
		const loadMoreStatus = localStorage.getItem('loadMoreStatus');
		const isAllButtonSelected = $('button[data-tag-category="All"]').hasClass('selected');

		if (loadMoreStatus === 'visible') {
			$('.card[data-tag-category="All"]').show();
			$('.category-explore-wrapper').hide();
		} else {
			$('.load-more-hide').hide();
			$('.category-explore-wrapper').show();
		}

		$('#loadMore').on('click', () => {
			$('.load-more-hide[data-tag-category="All"] ').show();
			localStorage.setItem('loadMoreStatus', $('.load-more-hide[data-tag-category="All"] ').is(':visible') ? 'visible' : 'hidden');
			$('.category-explore-wrapper').hide();
		});
	}

	handleFiltering() {
		$('.tag-filter-button').on('click', (e) => {
			$('.tag-filter-button.selected').removeClass('selected');

			$(e.currentTarget).addClass('selected');

			if (e.currentTarget.dataset.tagCategory !== 'All') {
				let category = e.currentTarget.dataset.tagCategory;
				$(`.content-category-uplift.carousel-related-content .card:not([data-tag-category="${category}"])`).hide();
				$('.category-results-wrapper').hide();

				if ($(`.content-category-uplift.carousel-related-content .card[data-tag-category="${category}"]`) && $(`.content-category-uplift.carousel-related-content .card[data-tag-category="${category}"]`).length > 0) {
					$(`.content-category-uplift.carousel-related-content .card[data-tag-category="${category}"]`).show();
				} else {
					$('.category-results-wrapper').css('display', 'flex');
				}

				$('.category-explore-wrapper').hide();
			}

			if (e.currentTarget.dataset.tagCategory === 'All') {
				const loadMoreStatus = localStorage.getItem('loadMoreStatus');
				if (loadMoreStatus === 'visible') {
					$('.card[data-tag-category="All"]').show();
					$('.card:not([data-tag-category="All"])').hide();
					$('.category-explore-wrapper').hide();
				} else {
					$('.card:not(.load-more-hide)[data-tag-category="All"]').show();
					$('.load-more-hide').hide();
					$('.category-explore-wrapper').show();
				}
			} 
		});
	}

	fadeinRegister() {
		if (!window.Launchpad.pageBuilderEditMode) {
			const elements = $('.js-entry');
			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						this.showCallback(entry.target);
						observer.unobserve(entry.target);
					}
				});
			});
			elements.each((i, e) => {
				observer.observe(e);
			});
		}
	}

	showCallback(ele) {
		this.handleLeftToRightAnimation();
	}

	handleLeftToRightAnimation() {
		setTimeout(() => {
			const anchorElements = document.querySelectorAll('.tag-filter-button.ftl-animate');

			// Add the 'fade-in-LtF' class to each element with a delay
			anchorElements.forEach((item, index) => {
				setTimeout(() => {
					item.classList.add('fade-in-LtF');
				}, index * 200); // Delay by 0.2 seconds per item
			});
		}, 10);
	}
}

export default ContentCategory;

$(() => {
    const contentCategory = new ContentCategory();
    contentCategory.init();
});